import Vue from 'vue';
import Vuex, { Store, Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
// import { getters } from './getters'
import { RootState } from '@/store/types';
import { IReviewForm, ReviewForm } from '@/entities';

Vue.use(Vuex);
const notification = {
    snack: false,
    text: '',
    color: '',
    timeOut: 6000
};
const data = {
    override: false,
    reviews: [],
    usedTemplate: {},
    totalScore: undefined,
    overallRating: undefined,
    recommendation: undefined,
    comments: undefined,
    reviewerId: undefined,
    applicationId: undefined,
    _id: undefined,
    version: undefined,
    status: undefined,
    notification: notification
};

export const state: IReviewForm = new ReviewForm(data);
const namespaced: boolean = true;

export const reviewForm: Module<IReviewForm, RootState> = {
    namespaced,
    state,
    actions,
    mutations
}
